import * as DisplayTypes from 'customer-data-filters-ui/filterQueryFormat/DisplayTypes';
import { Map as ImmutableMap } from 'immutable';
import { getOperatorTranslationKey } from './FilterOperatorTranslations';
import { isOperatorIncludesObjectsWithNoValueSet } from 'customer-data-filters-ui/utils/defaultNullValue';
import DisplayValueAssociation from 'customer-data-filters-ui/components/display/DisplayValueAssociation';
import DisplayValueBoolean from 'customer-data-filters-ui/components/display/DisplayValueBoolean';
import DisplayValueCta from 'customer-data-filters-ui/components/display/DisplayValueCta';
import DisplayValueDate from 'customer-data-filters-ui/components/display/DisplayValueDate';
import DisplayValueDuration from 'customer-data-filters-ui/components/display/DisplayValueDuration';
import DisplayValueEmailLink from 'customer-data-filters-ui/components/display/DisplayValueEmailLink';
import DisplayValueEnumeration from 'customer-data-filters-ui/components/display/DisplayValueEnumeration';
import DisplayValueExternalOption from 'customer-data-filters-ui/components/display/DisplayValueExternalOption';
import DisplayValueNumber from 'customer-data-filters-ui/components/display/DisplayValueNumber';
import DisplayValuePercentage from 'customer-data-filters-ui/components/display/DisplayValuePercentage';
import DisplayValueProperty from 'customer-data-filters-ui/components/display/DisplayValueProperty';
import DisplayValueRollingDate from 'customer-data-filters-ui/components/display/DisplayValueRollingDate';
import DisplayValueRollingInequality from 'customer-data-filters-ui/components/display/DisplayValueRollingInequality';
import DisplayValueRollingInequalityWithUnit from 'customer-data-filters-ui/components/display/DisplayValueRollingInequalityWithUnit';
import DisplayValueRollingPropertyUpdated from 'customer-data-filters-ui/components/display/DisplayValueRollingPropertyUpdated';
import DisplayValueText from 'customer-data-filters-ui/components/display/DisplayValueText';
import DisplayValueRegex from 'customer-data-filters-ui/components/display/DisplayValueRegex';
import FieldDefinitionType from 'customer-data-filters-ui/components/propTypes/FieldDefinitionType';
import FilterOperatorType from 'customer-data-filters-ui/components/propTypes/FilterOperatorType';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import FormattedList from 'I18n/components/FormattedList';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import ImmutablePropTypes from 'react-immutable-proptypes';
import PropTypes from 'prop-types';
import RestrictedAsset from 'customer-data-filters-ui/components/common/RestrictedAsset';
import { Fragment, PureComponent } from 'react';
import { Link } from 'foundations-components/transitional/components/Link';
import emptyFunction from 'react-utils/emptyFunction';
import getIn from 'transmute/getIn';
import { isExternalOptionsField } from 'customer-data-filters-ui/utils/isExternalOptionsField';
import * as UnifiedEventPropertyTypes from 'customer-data-filters-ui/filterQueryFormat/UnifiedEventPropertyTypes';
import { __ANY_CTA } from 'customer-data-filters-ui/converters/listSegClassic/ListSegConstants';
import MatchStatusIconCircle from 'customer-data-filters-ui/components/operator/MatchStatusIconCircle';
import { RemoveIcon, SuccessIcon } from 'foundations-assets';
import DisplayValueRollingDatePoint from '../display/DisplayValueRollingDatePoint';
import DisplayValueCurrencyCode from '../display/DisplayValueCurrencyCode';
import MissingAssociationBranchFilter from '../../filterQueryFormat/operator/MissingAssociationBranchFilter';
import DisplayMissingAssociationBranchFilter from './DisplayMissingAssociationBranchFilter';
import DisplayValueDateStaticOrDynamic from '../display/DisplayValueDateStaticOrDynamic';
import DisplayValueDateWithTime from '../display/DisplayValueDateWithTime';
import { isExternalOptionsEnum } from '../../utils/isExternalOptionsEnum';
import { isRelativeTimeProperty } from '../../utils/isRelativeTimeProperty';
import { OWNER as OwnerReferenceObjectType, TEAM as TeamReferenceObjectType
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'refe... Remove this comment to see the full error message
} from 'reference-resolvers/constants/ReferenceObjectTypes';
import { OWNER as OwnerExternalOptionType, TEAM as TeamExternalOptionType } from 'customer-data-objects/externalOptions/ExternalOptionsReferenceTypes';
import styled from 'foundations-theming/utils';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const HIGH_VALUE_FIELD = 'highValue';
const VALUE_FIELD = 'value';
const matchDataByStatus = {
  // @ts-expect-error ts-migrate(2464) FIXME: A computed property name must be of type 'string',... Remove this comment to see the full error message
  [false]: {
    IconComponent: RemoveIcon,
    iconColor: 'icon-alert-default'
  },
  // @ts-expect-error ts-migrate(2464) FIXME: A computed property name must be of type 'string',... Remove this comment to see the full error message
  [true]: {
    IconComponent: SuccessIcon,
    iconColor: 'fill-positive-default'
  }
};
export const getValueComponent = (fieldDefinitions, operator, filterFamily, getIsUngated, getOperatorsForType) => {
  const field = operator.field;
  const CustomValueComponent = getIn([field.name, 'ValueComponent'], fieldDefinitions);
  if (CustomValueComponent) {
    return CustomValueComponent;
  }
  const fieldType = getIn([field.name, 'inputType'], fieldDefinitions) || getIn([field.type, 'inputType'], fieldDefinitions) || field.displayType || field.type;
  const displayType = operator.constructor.displayType === DisplayTypes.DefaultDisplayType ? fieldType : operator.constructor.displayType;

  // OWNER reference fields must use a display component that supports a
  // ReferenceResolver even if its configured for external options to allow
  // the UI to use the FilterOperatorOwnerInput component
  if (((field === null || field === void 0 ? void 0 : field.referencedObjectType) === OwnerReferenceObjectType || (field === null || field === void 0 ? void 0 : field.externalOptionsReferenceType) === OwnerExternalOptionType) && displayType !== DisplayTypes.RollingPropertyUpdatedDisplayType) {
    return DisplayValueEnumeration;
  }

  // TEAM reference fields must use a display component that supports a
  // ReferenceResolver even if its configured for external options to allow
  // the UI to use the FilterOperatorTeamInput component
  if (((field === null || field === void 0 ? void 0 : field.referencedObjectType) === TeamReferenceObjectType || (field === null || field === void 0 ? void 0 : field.externalOptionsReferenceType) === TeamExternalOptionType) && displayType !== DisplayTypes.RollingPropertyUpdatedDisplayType) {
    return DisplayValueEnumeration;
  }
  if (isExternalOptionsEnum(field, getIsUngated) && isExternalOptionsField(field, filterFamily, getIsUngated)) {
    // some operators need a special display component
    if (displayType === DisplayTypes.NumberDisplayType || displayType === DisplayTypes.StringDisplayType) {
      return DisplayValueExternalOption;
    }
  }
  if (isRelativeTimeProperty(field) && typeof getOperatorsForType === 'function') {
    // We did not add support for relative time properties to the XOFilterEditor
    // filters created on these properties have standard date filters, and these operators are not compatible with relative time properties
    // if we find a operator that is not compatible with relative time properties, we need to use the standard date filter value display component
    const operators = getOperatorsForType(field.type, filterFamily, getIsUngated, {
      isRelativeTimeProperty: true
    });
    if (operators && operators.includes(operator.constructor)) {
      return DisplayValueDuration;
    }
  }
  if (field.type === 'number' && field.numberDisplayHint === 'duration' && operator.constructor.displayType === DisplayTypes.DefaultDisplayType) {
    return DisplayValueDuration;
  }
  if (field.type === 'number' && field.numberDisplayHint === 'percentage' && operator.constructor.displayType === DisplayTypes.DefaultDisplayType) {
    return DisplayValuePercentage;
  }
  if (operator.constructor.displayType === DisplayTypes.MomentDate) {
    return DisplayValueDate;
  }
  if (operator.constructor.displayType === DisplayTypes.MomentDateWithTime) {
    return DisplayValueDateWithTime;
  }
  switch (displayType) {
    case DisplayTypes.AssociationDisplayType:
      return DisplayValueAssociation;
    case DisplayTypes.BooleanDisplayType:
      return DisplayValueBoolean;
    case DisplayTypes.CtaDisplayType:
      return DisplayValueCta;
    case DisplayTypes.DateDisplayType:
    case DisplayTypes.DatetimeDisplayType:
      return DisplayValueDate;
    case DisplayTypes.EmailLinkDisplayType:
      return DisplayValueEmailLink;
    case DisplayTypes.EmailSubscriptionDisplayType:
    case DisplayTypes.CommunicationSubscriptionDisplayType:
    case DisplayTypes.EnumerationDisplayType:
    case UnifiedEventPropertyTypes.OBJECT_COORDINATES:
      return isExternalOptionsField(field, filterFamily, getIsUngated) ? DisplayValueExternalOption : DisplayValueEnumeration;
    case DisplayTypes.MultiCurrencyCurrencyCode:
      return DisplayValueCurrencyCode;
    case DisplayTypes.NumberDisplayType:
      return DisplayValueNumber;
    case DisplayTypes.PercentageDisplayType:
      return DisplayValuePercentage;
    case DisplayTypes.PropertyDisplayType:
      return DisplayValueProperty;
    case DisplayTypes.RollingPropertyUpdatedDisplayType:
      return DisplayValueRollingPropertyUpdated;
    case DisplayTypes.RollingDateDisplayType:
      return DisplayValueRollingDate;
    case DisplayTypes.DateStaticOrDynamicDisplayType:
      return DisplayValueDateStaticOrDynamic;
    case DisplayTypes.RollingDatePointDisplayType:
      return DisplayValueRollingDatePoint;
    case DisplayTypes.RollingInequalityDisplayType:
      return DisplayValueRollingInequality;
    case DisplayTypes.RollingWithUnitDisplayType:
      return DisplayValueRollingInequalityWithUnit;
    case DisplayTypes.RegexString:
      return DisplayValueRegex;
    case DisplayTypes.NoDisplayType:
      return undefined;
    default:
      return DisplayValueText;
  }
};
const BoldB = styled.b.withConfig({
  displayName: "FilterOperatorDisplay__BoldB",
  componentId: "sc-1ewgaqv-0"
})(({
  theme
}) => ({
  fontWeight: theme.typography['body-125'].fontWeight
}));
const PassB = styled.b.withConfig({
  displayName: "FilterOperatorDisplay__PassB",
  componentId: "sc-1ewgaqv-1"
})(({
  theme
}) => ({
  paddingBottom: theme.space[100],
  paddingLeft: theme.space[50],
  paddingRight: theme.space[50],
  paddingTop: theme.space[100],
  whiteSpace: 'nowrap'
}));
const FailB = styled.b.withConfig({
  displayName: "FilterOperatorDisplay__FailB",
  componentId: "sc-1ewgaqv-2"
})(({
  theme
}) => ({
  paddingBottom: theme.space[100],
  paddingTop: theme.space[100],
  whiteSpace: 'nowrap'
}));
const defaultProps = {
  fieldDefinitions: ImmutableMap(),
  getFamilyValueResolver: getIn(['field', 'referencedObjectType']),
  getLabelString: any => any.toString(),
  getReferencedObjectType: emptyFunction,
  operatorValueDisplayCutoffCount: 10
};
export default class FilterOperatorDisplay extends PureComponent {
  getAssociatedObjectName() {
    const {
      filterFamily,
      getFilterFamilyObjectName
    } = this.props;
    const associatedObjectName = typeof getFilterFamilyObjectName === 'function' ? getFilterFamilyObjectName(filterFamily, true) : filterFamily;
    return associatedObjectName;
  }
  renderLabel() {
    const {
      getLabelString,
      isReadOnly,
      isXoEnabled,
      hideRestrictedAsset,
      filterFamily,
      operator: {
        field
      }
    } = this.props;
    if (hideRestrictedAsset && field.userHasNoAccess) {
      return /*#__PURE__*/_jsx(RestrictedAsset, {
        filterFamily: filterFamily
      });
    }
    const Component = isReadOnly ? 'strong' : Link;
    if (!isXoEnabled) {
      return /*#__PURE__*/_jsx("span", {
        "data-selenium-test": "FilterOperatorDisplay-filters2",
        children: getLabelString(field, filterFamily)
      });
    }
    return /*#__PURE__*/_jsx(Component, {
      children: getLabelString(field, filterFamily)
    });
  }
  renderValue(fieldName) {
    const {
      currencyCode,
      getIsUngated,
      data,
      fieldDefinitions,
      filterFamily,
      getFamilyValueResolver,
      getReferencedObjectType,
      getSpecialOptionsForReferenceType,
      isReadOnly,
      isXoEnabled,
      matchingFilterValues,
      operator,
      operatorValueDisplayCutoffCount,
      hideRestrictedAsset,
      getOperatorsForType
    } = this.props;
    if (hideRestrictedAsset && operator.field.userHasNoAccess && operator.value !== __ANY_CTA) {
      return /*#__PURE__*/_jsx(RestrictedAsset, {
        filterDisplayElement: "value",
        filterFamily: filterFamily
      });
    }
    const ValueComponent = getValueComponent(fieldDefinitions, operator, filterFamily, getIsUngated, getOperatorsForType);
    const isInexclusive = operator.constructor.isInexclusive(fieldName);
    const isIterable = operator.constructor.isIterableField(fieldName);
    const specialOptions = getSpecialOptionsForReferenceType(getReferencedObjectType(operator), filterFamily);
    const value = operator.get(fieldName);
    const hasValueFieldAndItsEmpty = operator.has(fieldName) && (value === null || value === undefined);
    if (!ValueComponent || hasValueFieldAndItsEmpty) {
      return '';
    }
    const sharedValueComponentProps = {
      currencyCode,
      data,
      fieldDefinitions,
      filterFamily,
      getFamilyValueResolver,
      getReferencedObjectType,
      operator,
      specialOptions,
      getIsUngated
    };
    if (!isIterable) {
      return /*#__PURE__*/_jsx(BoldB, {
        children: /*#__PURE__*/_jsx(ValueComponent, Object.assign({}, sharedValueComponentProps, {
          fieldName: [fieldName],
          value: value
        }))
      });
    }
    const operatorValueDisplayOverflowCount = isIterable && isXoEnabled && !isReadOnly ? operator.get(fieldName).size - operatorValueDisplayCutoffCount : 0;
    const operatorValues = operator.get(fieldName).valueSeq();
    const operatorDisplayValues = operatorValueDisplayOverflowCount > 1 ? operatorValues.take(operatorValueDisplayCutoffCount) : operatorValues;
    return /*#__PURE__*/_jsx(FormattedList, {
      exclusive: !isInexclusive,
      children: operatorDisplayValues.map((valueItem, i) => {
        const matchData = matchingFilterValues &&
        // @ts-expect-error ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
        matchDataByStatus[matchingFilterValues.includes(valueItem)];
        const contents = /*#__PURE__*/_jsxs(_Fragment, {
          children: [/*#__PURE__*/_jsx(MatchStatusIconCircle, {
            matchData: matchData
          }), /*#__PURE__*/_jsx(ValueComponent, Object.assign({}, sharedValueComponentProps, {
            fieldName: [fieldName, i],
            value: valueItem
          }))]
        });
        if (matchingFilterValues && matchingFilterValues.includes(valueItem)) {
          return /*#__PURE__*/_jsx(PassB, {
            children: contents
          }, i);
        } else if (matchingFilterValues && !matchingFilterValues.includes(valueItem)) {
          return /*#__PURE__*/_jsx(FailB, {
            children: contents
          }, i);
        } else {
          return /*#__PURE__*/_jsx(BoldB, {
            children: contents
          }, i);
        }
      }).concat(...(operatorValueDisplayOverflowCount > 1 ? [/*#__PURE__*/_jsx(BoldB, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "customerDataFiltersUI.customerDataFilters.FilterEditorOperatorDisplay.valueOverflowCount",
          options: {
            count: operatorValueDisplayOverflowCount
          }
        })
      }, "overflow")] : []))
    });
  }
  renderEmptyInBold() {
    const {
      matchingFilterValues,
      isMatchingEmptyPropertyValue
    } = this.props;
    const matchData =
    // @ts-expect-error ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
    matchingFilterValues && matchDataByStatus[isMatchingEmptyPropertyValue];
    const contents = /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(MatchStatusIconCircle, {
        matchData: matchData
      }), /*#__PURE__*/_jsx(FormattedHTMLMessage, {
        message: "customerDataFiltersUI.customerDataFilters.FilterOperatorTranslations.WITH_UNKNOWN.EmptyInBold"
      })]
    });
    if (matchingFilterValues && isMatchingEmptyPropertyValue) {
      return /*#__PURE__*/_jsx(PassB, {
        as: "span",
        children: contents
      });
    } else if (matchingFilterValues && !isMatchingEmptyPropertyValue) {
      return /*#__PURE__*/_jsx(FailB, {
        as: "span",
        children: contents
      });
    } else {
      return /*#__PURE__*/_jsx("span", {
        children: contents
      });
    }
  }
  render() {
    const {
      operator,
      operator: {
        constructor: ctor,
        field
      },
      includeObjectsWithNoAssociatedObjects,
      translationPrefix
    } = this.props;
    const labelOptions = {
      // count is used to determine which translation to use, it shouldn't ever be displayed
      count: field.displayType === DisplayTypes.CountDisplayType ? parseInt(operator.get(VALUE_FIELD), 10) : undefined,
      highValue: operator.has(HIGH_VALUE_FIELD) ? this.renderValue(HIGH_VALUE_FIELD) : undefined,
      rollingOffset: operator.has('rollingOffset') ? parseInt(operator.get('rollingOffset') || 0, 10) : undefined,
      label: this.renderLabel(),
      value: this.renderValue(VALUE_FIELD),
      empty: this.renderEmptyInBold()
    };
    if (ctor && ctor.getOperatorDisplay) {
      return ctor.getOperatorDisplay(labelOptions);
    }
    if (ctor === MissingAssociationBranchFilter) {
      return /*#__PURE__*/_jsx(DisplayMissingAssociationBranchFilter, {});
    }
    const addOrUnknown = isOperatorIncludesObjectsWithNoValueSet(operator);
    const addAnniversary = operator.ignoreYear;
    return /*#__PURE__*/_jsxs(Fragment, {
      children: [/*#__PURE__*/_jsx(FormattedReactMessage, {
        message: getOperatorTranslationKey(ctor, field, addOrUnknown, addAnniversary, translationPrefix),
        options: labelOptions
        // @ts-expect-error ts-migrate(2769) FIXME: No overload matches this call.
        ,
        style: {
          wordWrap: 'break-word'
        }
      }), "\xA0", includeObjectsWithNoAssociatedObjects && /*#__PURE__*/_jsx(FormattedHTMLMessage, {
        message: "customerDataFiltersUI.customerDataFilters.FilterOperatorInput.includingObjectsWithNoAssociatedObjects",
        options: {
          associatedObjectName: this.getAssociatedObjectName()
        }
      })]
    });
  }
}
FilterOperatorDisplay.propTypes = {
  currencyCode: PropTypes.string.isRequired,
  data: ImmutablePropTypes.map,
  fieldDefinitions: ImmutablePropTypes.mapOf(FieldDefinitionType),
  filterFamily: PropTypes.string.isRequired,
  getFamilyValueResolver: PropTypes.func.isRequired,
  getFilterFamilyObjectName: PropTypes.func,
  getLabelString: PropTypes.func.isRequired,
  getReferencedObjectType: PropTypes.func.isRequired,
  getSpecialOptionsForReferenceType: PropTypes.func.isRequired,
  hideRestrictedAsset: PropTypes.bool,
  includeObjectsWithNoAssociatedObjects: PropTypes.bool,
  isMatchingEmptyPropertyValue: PropTypes.bool,
  isReadOnly: PropTypes.bool,
  isXoEnabled: PropTypes.bool,
  matchingFilterValues: PropTypes.arrayOf(PropTypes.string),
  operator: FilterOperatorType.isRequired,
  operatorValueDisplayCutoffCount: PropTypes.number.isRequired,
  translationPrefix: PropTypes.string,
  getIsUngated: PropTypes.func.isRequired,
  getOperatorsForType: PropTypes.func
};
FilterOperatorDisplay.defaultProps = defaultProps;